// Count pills, hidden at 0. Sprint 14 (§8.5): the missed check-in pill uses the destructive token. Sprint 15
// (§9.1): the notes-to-review pill is neutral, so the two never look alike.
const TONES = {
  danger: 'bg-destructive text-destructive-foreground',
  neutral: 'bg-muted text-foreground',
} as const;

export function CountPill({ count, label, tone = 'danger' }: { count: number; label: string; tone?: keyof typeof TONES }): JSX.Element | null {
  if (count <= 0) return null;
  return (
    <span
      className={`ml-auto inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-[11px] font-medium leading-5 ${TONES[tone]}`}
      aria-label={`${count} ${label}`}
      title={`${count} ${label}`}
    >
      {count}
    </span>
  );
}

export const CHECKIN_PROBLEM_LABEL = 'check-in problems';
export const NOTES_TO_REVIEW_LABEL = 'notes to review';
